<template>
  <div>
    <el-dialog
      width="1200px"
      :title="`选择物料(已选${selfList.length})`"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <template slot="title">
        <span class="f-s-16">
          <span>选择物料</span>
          <span class="c-red">(已选{{ selfList.length }})</span>
        </span>
      </template>
      <div class="page-main">
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          :height="this.$util.getViewHeight() - 310"
          @keydown="tableKeydown"
          @checkbox-change="tableCheckboxChange"
          @checkbox-all="tableCheckboxChange"
        >
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_list_chan_pin_tu="{ row }">
            <e-upload-image
              v-if="row.list_chan_pin_tu"
              :list.sync="row.list_chan_pin_tu"
              disabled
            />
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selfShow: false,
      selfList: [],
      filterData: {},
      detailId: '',
      headerFilterUrl: '/admin/gcvip/checkBill2/list3YuanLiaoSearchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        checkboxConfig: {
          trigger: 'row',
          reserve: true
        },
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          {
            fixed: 'left',
            type: 'checkbox',
            width: 40
          },
          {
            fixed: 'left',
            title: '序号',
            type: 'seq',
            width: 40
          },
          { field: 'bill_code', title: '销售单号', slots: { header: 'header_input' } },
          { field: 'status_str', title: '订单状态', slots: { header: 'header_input' } },
          { field: 'ding_dan_lei_xing', title: '订单类型', slots: { header: 'header_input' } },
          { field: 'bill_date', title: '销售日期', slots: { header: 'header_input' } },
          { field: 'jiao_huo_ri_qi', title: '交货日期', slots: { header: 'header_input' } },
          {
            title: '原料图片',
            field: 'list_chan_pin_tu',
            slots: { default: 'default_list_chan_pin_tu' },
            width: 63
          },
          {
            title: '原料名称',
            field: 'name',
            width: 120,
            slots: { header: 'header_input' }
          },
          {
            title: '规格(mm)',
            field: 'spec',
            width: 120,
            slots: { header: 'header_input' }
          },
          {
            title: '单位',
            field: 'unit',
            width: 60,
            slots: { header: 'header_input' }
          },
          {
            title: '数量',
            field: 'counts',
            slots: { header: 'header_input' }
          },
          {
            title: '单价(元)',
            field: 'goods_price',
            slots: { header: 'header_input' }
          },
          {
            title: '金额(元)',
            field: 'goods_amount',
            slots: { header: 'header_input' }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfList = this.$util.deepCopy(this.list)
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let params = {
        currentPage: this.tableOptions.pagerConfig.currentPage,
        pageSize: this.tableOptions.pagerConfig.pageSize,
        bill_status1: '订单',
        filterData: this.filterData,
        sortData: { id: 'desc' }
      }
      if (
        params.filterData.status_str &&
        params.filterData.status_str !== '暂存' &&
        params.filterData.status_str !== '已驳回'
      ) {
        params.bill_status1 = params.filterData.status_str
      } else {
        params.filterData.status_str = ''
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/checkBill2/list3YuanLiao',
        data: params
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = this.$util.deepCopy(res.data.page.list)
            this.tableOptions.data.forEach((item) => {
              // 初始化绑定id、bind_id、数量、金额、备注
              let bind_id = item.id
              item.id = ''
              item.bind_id = bind_id
            })
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
            this.tableOptions.data.forEach((itemSt) => {
              this.selfList.forEach((itemNd) => {
                if (itemNd.bind_id === itemSt.bind_id) {
                  this.$nextTick(() => {
                    this.$refs.refTable.setCheckboxRow([itemSt], true) // 选中checkbox
                  })
                }
              })
            })
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 表格-复选框更新
    tableCheckboxChange(params) {
      let resultDiff = this.selfList.filter((itemSt) => {
        let isDiff = this.tableOptions.data.every((itemNd) => {
          return itemSt.bind_id !== itemNd.bind_id
        })
        return isDiff
      })
      let resultCheck = [...params.records]
      let result = [...resultDiff, ...resultCheck] // 跨页选中
      this.selfList = result
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        params.$event.preventDefault() // 阻止默认滚动行为
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$emit('success', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
